import { render, staticRenderFns } from "./CfoMarginEvents.vue?vue&type=template&id=4f9b3cb8&scoped=true"
import script from "./CfoMarginEvents.vue?vue&type=script&lang=js"
export * from "./CfoMarginEvents.vue?vue&type=script&lang=js"
import style0 from "./CfoMarginEvents.vue?vue&type=style&index=0&id=4f9b3cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b3cb8",
  null
  
)

export default component.exports